// PreventiApp · Sprint 3 · Etapa 7 — Página de Colegios (INSIDE only).
import React, { useEffect, useState } from 'react';
import { listColegios, updateColegio, createColegio } from '../../data/supabaseAdmin';

const ESTADOS = ['activo', 'inactivo', 'suspendido', 'piloto', 'archivado'];

export default function AdminColegios() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [editing, setEditing] = useState(null);
  const [creating, setCreating] = useState(false);
  const [draft, setDraft] = useState({});

  const reload = async () => {
    setLoading(true); setError('');
    try { setItems(await listColegios()); } catch (e) { setError(e.message); } finally { setLoading(false); }
  };
  useEffect(() => { reload(); }, []);

  const startEdit = (c) => { setEditing(c.id); setDraft({ ...c }); };
  const startCreate = () => { setCreating(true); setDraft({ rbd: '', nombre: '', dependencia: '', region: '', comuna: '', estado: 'activo', plan_contrato: 'piloto' }); };
  const cancel = () => { setEditing(null); setCreating(false); setDraft({}); };

  const save = async () => {
    try {
      if (creating) await createColegio(draft);
      else await updateColegio(editing, {
        nombre: draft.nombre, sostenedor: draft.sostenedor, dependencia: draft.dependencia,
        region: draft.region, comuna: draft.comuna, estado: draft.estado, plan_contrato: draft.plan_contrato,
      });
      cancel(); reload();
    } catch (e) { alert(`Error: ${e.message}`); }
  };

  return (
    <div className="p-8 max-w-6xl" data-testid="page-colegios">
      <div className="flex items-center justify-between mb-5">
        <div>
          <h1 className="text-2xl font-extrabold text-[#0B1B5E]">Gestión de colegios</h1>
        </div>
        <button
          onClick={startCreate}
          data-testid="colegio-btn-nuevo"
          className="px-4 py-2 rounded-xl bg-[#5346E6] hover:bg-[#0B1B5E] text-white text-sm font-bold"
        >
          + Nuevo colegio
        </button>
      </div>

      {error && <div className="mb-4 p-3 rounded-xl bg-[#FEE2E2] text-[#991B1B] text-sm" data-testid="colegio-error">{error}</div>}
      {loading && <p className="text-[#475472] text-sm">Cargando…</p>}

      {(creating || editing) && (
        <div className="mb-5 p-5 rounded-2xl bg-white border border-[#5346E6]/30 shadow-sm" data-testid="colegio-form">
          <p className="text-sm font-extrabold text-[#0B1B5E] mb-3">{creating ? 'Alta de colegio' : `Editar: ${draft.nombre}`}</p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-xs">
            <label className="block">RBD <input data-testid="colegio-input-rbd" disabled={!creating} value={draft.rbd || ''} onChange={(e) => setDraft({ ...draft, rbd: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7] disabled:bg-[#F4F7FE]" /></label>
            <label className="block">Nombre <input data-testid="colegio-input-nombre" value={draft.nombre || ''} onChange={(e) => setDraft({ ...draft, nombre: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7]" /></label>
            <label className="block">Sostenedor <input value={draft.sostenedor || ''} onChange={(e) => setDraft({ ...draft, sostenedor: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7]" /></label>
            <label className="block">Dependencia <input value={draft.dependencia || ''} onChange={(e) => setDraft({ ...draft, dependencia: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7]" /></label>
            <label className="block">Región <input value={draft.region || ''} onChange={(e) => setDraft({ ...draft, region: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7]" /></label>
            <label className="block">Comuna <input value={draft.comuna || ''} onChange={(e) => setDraft({ ...draft, comuna: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7]" /></label>
            <label className="block">Estado
              <select data-testid="colegio-input-estado" value={draft.estado || 'activo'} onChange={(e) => setDraft({ ...draft, estado: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7]">
                {ESTADOS.map((s) => <option key={s} value={s}>{s}</option>)}
              </select>
            </label>
            <label className="block">Plan <input value={draft.plan_contrato || ''} onChange={(e) => setDraft({ ...draft, plan_contrato: e.target.value })} className="mt-1 w-full px-3 py-2 rounded-lg border border-[#DDE6F7]" /></label>
          </div>
          <div className="mt-4 flex gap-2">
            <button data-testid="colegio-btn-save" onClick={save} className="px-4 py-2 rounded-xl bg-[#10B981] hover:bg-[#059669] text-white text-sm font-bold">Guardar</button>
            <button onClick={cancel} className="px-4 py-2 rounded-xl border border-[#DDE6F7] text-[#475472] text-sm font-bold">Cancelar</button>
          </div>
        </div>
      )}

      <div className="bg-white border border-[#E5EAF5] rounded-2xl overflow-hidden">
        <table className="w-full text-sm" data-testid="colegios-table">
          <thead className="bg-[#F4F7FE] text-[#0B1B5E] text-xs">
            <tr>
              <th className="px-4 py-3 text-left font-bold">RBD</th>
              <th className="px-4 py-3 text-left font-bold">Nombre</th>
              <th className="px-4 py-3 text-left font-bold">Dependencia</th>
              <th className="px-4 py-3 text-left font-bold">Estado</th>
              <th className="px-4 py-3 text-left font-bold">Soporte INSIDE</th>
              <th className="px-4 py-3" />
            </tr>
          </thead>
          <tbody>
            {items.map((c) => {
              const soporteVigente = c.permite_soporte_inside_hasta && new Date(c.permite_soporte_inside_hasta) > new Date();
              return (
                <tr key={c.id} className="border-t border-[#E5EAF5]" data-testid={`colegio-row-${c.rbd}`}>
                  <td className="px-4 py-3 font-mono">{c.rbd}</td>
                  <td className="px-4 py-3 font-bold text-[#0B1B5E]">{c.nombre}</td>
                  <td className="px-4 py-3 text-xs text-[#475472]">{c.dependencia || '—'}</td>
                  <td className="px-4 py-3"><span className={`px-2 py-0.5 rounded-full text-[10px] font-bold ${c.estado === 'activo' ? 'bg-[#DCFCE7] text-[#166534]' : 'bg-[#F4F7FE] text-[#475472]'}`}>{c.estado}</span></td>
                  <td className="px-4 py-3 text-xs">{soporteVigente ? <span className="text-[#B97A0D] font-bold">vigente hasta {new Date(c.permite_soporte_inside_hasta).toLocaleDateString('es-CL')}</span> : <span className="text-[#475472]">—</span>}</td>
                  <td className="px-4 py-3 text-right">
                    <button onClick={() => startEdit(c)} data-testid={`colegio-edit-${c.rbd}`} className="text-xs font-bold text-[#5346E6] hover:underline">Editar</button>
                  </td>
                </tr>
              );
            })}
            {!loading && items.length === 0 && (
              <tr><td colSpan={6} className="px-4 py-8 text-center text-sm text-[#475472]">Sin colegios visibles.</td></tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
